declare namespace $ {

	type $mol_select__value_shm_hitalama_duckdb_page_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['project_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_duckdb_page_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['projects_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_hitalama_duckdb_page_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_duckdb_page_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_check_box__title_shm_hitalama_duckdb_page_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['file_name'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_duckdb_page_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['file_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $shm_button_copy__title_shm_hitalama_duckdb_page_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['query_default'] >
		,
		ReturnType< $shm_button_copy['title'] >
	>
	type $shm_button_copy__button_sub_shm_hitalama_duckdb_page_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_button_copy['button_sub'] >
	>
	type $mol_view__sub_shm_hitalama_duckdb_page_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_duckdb_page_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['file_views'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_scroll__sub_shm_hitalama_duckdb_page_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_labeler__title_shm_hitalama_duckdb_page_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_duckdb_page_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_shm_hitalama_duckdb_page_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__value_shm_hitalama_duckdb_page_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['query'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_shm_hitalama_duckdb_page_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_labeler__title_shm_hitalama_duckdb_page_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_duckdb_page_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_minor__title_shm_hitalama_duckdb_page_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_duckdb_page_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['run'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_dump_value__value_shm_hitalama_duckdb_page_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['duckdb_res'] >
		,
		ReturnType< $mol_dump_value['value'] >
	>
	type $mol_page__title_shm_hitalama_duckdb_page_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_hitalama_duckdb_page_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_select__value_shm_hitalama_duckdb_page_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['logs_project_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_duckdb_page_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['projects_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_button_minor__title_shm_hitalama_duckdb_page_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_duckdb_page_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['logs_clear'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_shm_hitalama_duckdb_page_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['query_time'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $shm_button_copy__minimal_height_shm_hitalama_duckdb_page_29 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_button_copy['minimal_height'] >
	>
	type $shm_button_copy__text_shm_hitalama_duckdb_page_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['query_sql'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $mol_view__sub_shm_hitalama_duckdb_page_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text_code__text_shm_hitalama_duckdb_page_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['query_sql'] >
		,
		ReturnType< $mol_text_code['text'] >
	>
	type $mol_view__sub_shm_hitalama_duckdb_page_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_hitalama_duckdb_page_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_shm_hitalama_duckdb_page_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_hitalama_duckdb_page_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_duckdb_page['logs'] >
		,
		ReturnType< $mol_page['body'] >
	>
	export class $shm_hitalama_duckdb_page extends $mol_book2 {
		remote_url( ): string
		project_id( next?: string ): string
		projects_dict( ): Record<string, any>
		Project( ): $mol_select
		Project_label( ): $mol_labeler
		file_name( id: any): string
		file_checked( id: any, next?: boolean ): boolean
		File_check( id: any): $mol_check_box
		query_default( id: any, next?: string ): string
		Copy_icon( id: any): $mol_icon_clipboard_outline
		File_name_copy( id: any): $shm_button_copy
		File( id: any): $mol_view
		file_views( ): readonly(any)[]
		Files_list( ): $mol_list
		Files_scroll( ): $mol_scroll
		Files_label( ): $mol_labeler
		files_label( ): readonly(any)[]
		Project_and_files( ): $mol_view
		query( next?: string ): string
		Query( ): $mol_textarea
		Query_label( ): $mol_labeler
		run( next?: any ): any
		Run( ): $mol_button_minor
		duckdb_res( next?: any ): any
		Duckdb_dump( ): $mol_dump_value
		Query_page( ): $mol_page
		logs_project_id( next?: string ): string
		Logs_project( ): $mol_select
		logs_clear( next?: any ): any
		Logs_clear( ): $mol_button_minor
		query_time( id: any): string
		Query_time( id: any): $mol_paragraph
		query_sql( id: any): string
		Query_copy( id: any): $shm_button_copy
		Query_head( id: any): $mol_view
		Log_sql( id: any): $mol_text_code
		Query_log( id: any): $mol_view
		logs( ): readonly(any)[]
		Logs( ): $mol_page
		query_current( next?: string ): string
		remote_file_urls( ): readonly(any)[]
		pages( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.web.view.tree.d.ts.map